// Fetcher + adapter del dashboard de receptora — swap Q-118 §1 CERRADO (D-010):
// endpoint REAL GET public/recipients/:id?view=full (public-recipients.md).
// Lectura compuesta → viene ENVUELTA en el sobre público (0052): el payload
// vive en data.* → envelopeData() ANTES de adaptar (defecto que dejaba los
// stats en undefined y la UI en "Sin datos suficientes").
//
// Las pantallas consumen SOLO la interfaz adaptada; los literales de
// history[].outcome ('born'|'lost'|'en_curso'|null) están CONFIRMADOS contra
// el contrato real — sin normalización (null = sin dato, no "en curso").

import { api } from '../../core/network/api';
import { envelopeData } from '../../core/network/envelope';

const path = (id) => `public/recipients/${id}`;

export async function fetchRecipientDetail(id, { signal } = {}) {
    const { data } = await api.get(path(id), { params: { view: 'full' }, signal });
    return adapt(envelopeData(data));
}

// Proyección client-safe del payload real. `medical_events` NO existe en el
// canal público (operación interna, excluida por contrato) — no se adapta.
function adapt(raw) {
    if (!raw || raw.id == null) return null;
    return {
        id: raw.id,
        number: raw.number,
        name: raw.name,
        status: raw.status,
        farm: raw.farm ?? null,
        current_location: raw.current_location ?? null,
        transfers_count: raw.transfers_count ?? null,
        stats: raw.stats ?? null,
        current: raw.current ?? null,
        history: raw.history ?? [],
    };
}
